// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"049c39bf","453":"43596b53","455":"a9f529f9","977":"13fee781"}[chunkId] + ".chunk.js";
};